/**
 * Page Redirect Module
 *
 * Handles redirects for missing pages
 */

export const initPageRedirect = () => {
    // Redirect for missing pages
    const targetPathArray = ['blog', 'case-studies', 'resources', 'videos', 'webinars', 'industries', 'products'];
    const pagePath = window.location.href;

    /**
     * Check if page is missing and redirect to parent page
     * @param {string} pathToRedirect - Path to check and redirect
     */
    async function missingPageRedirect(pathToRedirect) {
        let pageMissing = false;
        if (pathToRedirect === 'products' && pagePath.includes('/products/details.')) {
            return;
        }

        if (pathToRedirect === 'trust-center/security-advisories') {
            const getResponse = await fetch(pagePath, { method: 'GET' });
            const parser = new DOMParser();
            const pageContents = parser.parseFromString(await getResponse.text(), 'text/html');
            const heroElement = pageContents.querySelector('.hero-banner');
            pageMissing = heroElement === null;
        } else {
            const headResponse = await fetch(pagePath, { method: 'HEAD' });
            pageMissing = headResponse.status >= 400 && headResponse.status < 600;
        }
        if (pageMissing) {
            const pathRegex = new RegExp(`^(.+?/${pathToRedirect.replaceAll('/', '/')})/.*$`);
            if (pathToRedirect === 'workforce-development-training') {
                window.location.href = pagePath.replace(pathRegex, '$1/training-course-catalog.html');
            } else {
                window.location.href = pagePath.replace(pathRegex, '$1.html');
            }
        }
    }

    // Check if current page matches any of the target paths and initiate redirect check
    const pathMatch = targetPathArray.find((path) => pagePath.includes(`/${path}/`));
    if (pathMatch) {
        missingPageRedirect(pathMatch);
    }
};
